module.exports = __webpack_public_path__ + "img/1+Xchaxun.bb7d0483.png";